import { render, staticRenderFns } from "./OrderInfo.vue?vue&type=template&id=4b299fc3&"
import script from "./OrderInfo.js?vue&type=script&lang=js&"
export * from "./OrderInfo.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports